import dateField from "../../common/date-field";
import decimalField from "../../common/decimal-field.vue";
import { hasValue } from "../../../utils/functions.js";

export default {
  name: "SingleSale",
  components: {
    dateField,
    decimalField
  },
  data() {
    return {
      countFilter: 0,
      loading: false,
      loadingTransaction: false,
      loadingSingleSale: false,
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0
      },
      baseUrl: this.GetEnviroment(),
      idTransaction: null,
      idMerchant: null,
      filter: this.FilterDefault(),
      transactions: [],
      singleSales: [],
      infoTransaction: this.InfoTransactionDefault(),
      infoSingleSale: this.InfoSingleSaleDefault(),
      relatedTransactions: null,
      isSeeing: false,
      modalTitle: null,
      mSteps: ["Cliente", "Pagamento", "Produto", "Histórico", "Splits", "Informações Adicionais", "Correlações", "Dados do Merchant"],
      mSingleSaleSteps: ["Cliente", "Produto", "Pagamento", "Venda"],
      transactionStatus: [],
      paymentMethods: [],
      mCurrentStep: 0,
      previousPageinfo: [],
      validatedFormValidation: false,
      window: {
        width: 0,
        height: 0
      }
    };
  },
  watch: {
    "pagination.PageNumber"() {
      this.ListSingleSales();
    },
    "pagination.RowsPerPage"() {
      this.ListSingleSales();
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.ListTransactionStatus();
    this.ListPaymentMethod();
    this.GetClass();
  },
  methods: {
    GetEnviroment() {
      let env = null;
      if (window.location.host.indexOf('-h') >= 0) {
        env = "staging";
      } else if (window.location.host.indexOf('local') >= 0) {
        env = "local";
      } else {
        env = "production"
      }

      return env;
    },
    Filter() {
      this.validatedFormValidation = true;
      this.$refs.ValidationForm.validate().then(isValid => {
        if (isValid && this.ValidateFilter()) {
          this.$bvModal.hide("mFilter");
          this.ListSingleSales();
        }
      });
    },
    OpenModalFilter() {
      this.$bvModal.show("mFilter");
    },
    ResetFilter() {
      this.filter = this.FilterDefault();
      this.countFilter = 0;
      this.transactions = [];
      this.singleSales = [];
      this.pagination.TotalItems = 0;
    },
    FilterDefault() {
      return {
        IdMerchant: null,
        IdTransaction: null,
        CustomerName: null,
        CustomerIdentity: null,
        Amount: null,
        CreatedDate: null,
        DueDate: null,
        SingleSaleHash: null,
        Status: null,
        TransactionStatus: null,
        Payment: null
      }
    },
    ValidateFilter() {
      this.countFilter = 0;
      Object.values(this.filter).map(value => { 
        if (hasValue(value)) {
          this.countFilter++;
        }
      });

      let retorno = true;
      if (this.countFilter == 0) {
        this.$makeToast("Filtro não pode estar vazio", "danger", "Filtro vazio");
        this.$bvModal.hide("mFilter");
        retorno = false;
      }

      return retorno;
    },
    ListSingleSales() {
      if (this.ValidateFilter()) {
        this.loading = true;
        let params = this.GetParamsData();
        this.$store
          .dispatch("ListSingleSales", { params: params })
          .then(response => {
            this.singleSales = response.Objects;
            this.pagination.TotalItems = response.TotalItems;
          })
          .catch(error => this.$makeToast(undefined, "danger", "Erro ao listar vendas avulsas", error))
          .finally(() => this.loading = false);
      }
    },
    GetParamsData(deletePagination = false) {
      let data = {
        ...this.pagination,
        "Object.IdTransaction": this.filter.IdTransaction,
        "Object.Merchant.Id": this.filter.IdMerchant,
        "Object.Customer.Name": this.filter.CustomerName,
        "Object.Customer.Identity": this.filter.CustomerIdentity,
        "Object.Amount": this.filter.Amount,
        "Object.CreatedDate": this.filter.CreatedDate,
        "Object.DueDate": this.filter.DueDate,
        "Object.SingleSaleHash": this.filter.SingleSaleHash,
        "Object.Status": this.filter.Status,
      };
      delete data.TotalItems;
      if (deletePagination) {
        delete data.PageNumber;
        delete data.RowsPerPage;
      }
      return data;
    },
    GetClass(infoObject = null) {
      if (!infoObject) {
        infoObject = this.infoTransaction;
      }
      
      if (infoObject != null && infoObject.Id > 0) {
        switch (infoObject.TransactionStatus.Code) {
          case "1":
            return "labelModal labelsecondary";
          case "2":
          case "5":
          case "6":
          case "12":
          case "19":
            return "labelModal labelwarning";
          case "11":
          case "14":
            return "labelModal labelinfo";
          case "3":
            return "labelModal labelsuccess";
          case "4":
            break;
          case "7":
          case "8":
          case "13":
            return " labelModal labeldanger";
        }
      }
    },
    OpenModal(i) {
      this.mCurrentStep = 0;
      this.Resetinfos();

      // View
      this.idTransaction = this.singleSales[i].IdTransaction;
      this.isSeeing = true;
      if (this.idTransaction != 0) {
        this.modalTitle = "Detalhes da transação";
        this.GetTransaction(this.idTransaction, this.singleSales[i].Merchant.Id);
        this.$bvModal.show("mFormTransaction");
      } else {
        this.modalTitle = "Detalhes da venda avulsa";
        this.GetSingleSale(this.singleSales[i].SingleSaleHash, this.singleSales[i].Merchant.Id);
        this.$bvModal.show("mFormSingleSale");
      }
    },
    HideModal() {
      this.$bvModal.hide("mFormTransaction");
      this.$bvModal.hide("mFormSingleSale");
    },
    ChangeGet(idTransaction, idMerchant) {
      this.mCurrentStep = 0;
      this.Resetinfos();

      // View
      this.idTransaction = idTransaction;
      this.isSeeing = true;
      this.modalTitle = "Detalhes da transação";
      this.GetTransaction(this.idTransaction, idMerchant);
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    InfoTransactionDefault() {
      return {
        Id: 0,
        Reference: null,
        Vendor: null,
        Application: null,
        Merchant:{
          Id: null
        },
        Customer: {
          Name: null,
          Identity: null,
          Email: null,
          Address: {
            ZipCode: null,
            Street: null,
            Number: null,
            District: null,
            Complement: null,
            City: {
              Name: null,
              Initials: null
            },
            State: {
              Initials: null
            }
          }
        },
        PaymentMethod: {
          Code: null,
          BankSlipNumber: null,
          DueDate: null,
          InstallmentQuantity: null
        },
        PaymentObject: {
          Symbol: null,
          Brand: {
            Code: null
          },
          Amount: null,
          Address: null,
          Provider: null,
          AdditionPayment: null,
          DiscountPayment: null,
          QrCode: null,
          BankData: {
            BankAgency: null,
            BankAgencyDigit: null,
            BankAccount: null,
            BankAccountDigit: null,
            Bank: {
              Name: null
            }
          }
        },
        Amount: null,
        PaymentDate: null,
        CreatedDate: null,
        CheckingAccounts: [],
        Splits: [],
        History: [],
        IsSplitter: false,
        Products: [],
        Plan: {
          Name: null
        },
        TransactionStatus: {
          Code: "1"
        },
        Merchant: {
          Name: null,
          Documents: null,
        },
        RelatedTransactions: null
      }
    },
    InfoSingleSaleDefault() {
      return {
        Name: null,
        Id: null,
        SingleSaleHash: null,
        CreatedDate: null,
        DueDate: null,
        ApiVersion: null,
        Products: [],
        PaymentMethods: [],
        Customer: {
          Name: null,
          Identity: null,
          Email: null,
          Phone: null,
          Address: {
            ZipCode: null,
            Street: null,
            Number: null,
            District: null,
            Complement: null,
            City: {
              Name: null,
            },
            State: {
              Initials: null
            }
          }
        },
      }
    },
    Resetinfos() {
      this.mCurrentStep = 0;
      this.idTransaction = 0;
      this.idMerchant = 0;
      this.infoTransaction = this.InfoTransactionDefault();
      this.infoSingleSale = this.InfoSingleSaleDefault();
    },
    GetTransaction(id, idMerchant) {
      this.loadingTransaction = true;
      this.$store
        .dispatch("GetTransaction", { id: id, idMerchant: idMerchant })
        .then(response => {
          this.infoTransaction = response;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao obter as informações da transação", error);
        })
        .finally(() => {
          this.loadingTransaction = false;
        });
    },
    GetSingleSale(singleSaleHash) {
      this.loadingSingleSale = true;
      this.$store
        .dispatch("GetSingleSale", { singleSaleHash })
        .then(response => {
          this.infoSingleSale = response;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao obter as informações da venda avulsa", error);
        })
        .finally(() => {
          this.loadingSingleSale = false;
        });
    },
    ProcessNextStep(nextStep = null, isSingleSale = false) {
      if (this.isSeeing) {
        if (nextStep != null) this.mCurrentStep = nextStep;
        else this.NextStep(isSingleSale);
        return;
      }
    },
    NextStep(isSingleSale = false) {
      const mSteps = isSingleSale ? this.mSingleSaleSteps : this.mSteps;
      if (this.mCurrentStep < mSteps.length - 1) {
        if (!isSingleSale && this.mCurrentStep == 3 && (this.infoTransaction.Splits == null || this.infoTransaction.Splits.length < 1)) {
          this.mCurrentStep += 2;
        } else if (!isSingleSale && this.mCurrentStep == 5 && this.infoTransaction.PaymentMethod.Code != '2') {
          this.mCurrentStep += 2;
        } else {
          this.mCurrentStep += 1;
        }
      }
    },
    BackStep(isSingleSale = false) {
      if (this.mCurrentStep >= 1) {
        if (!isSingleSale && this.mCurrentStep == 5 && (this.infoTransaction.Splits == null || this.infoTransaction.Splits.length < 1)) {
          this.mCurrentStep -= 2;
        } else if (!isSingleSale && this.mCurrentStep == 7 && this.infoTransaction.PaymentMethod.Code != '2') {
          this.mCurrentStep -= 2;
        } else {
          this.mCurrentStep -= 1;
        }
      }
    },
    GoToStep(e, stepToGo, isSingleSale = false) {
      e.preventDefault();

      const mSteps = isSingleSale ? this.mSingleSaleSteps : this.mSteps;
      if (stepToGo <= mSteps.length && stepToGo >= 0) {
        if (stepToGo < this.mCurrentStep) {
          this.mCurrentStep = stepToGo;
        } else {
          this.ProcessNextStep(stepToGo, isSingleSale);
        }
      }
    },
    ListTransactionStatus() {
      this.$store
        .dispatch("ListTransactionStatus", {})
        .then(response => {
          this.transactionStatus = response;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro carregar a lista de status", error);
        });
    },
    ListCreditCardRefused() {
      const todayDate = new Date().toISOString().slice(0, 10);
      const lastMonth = new Date(todayDate);
      lastMonth.setMonth(lastMonth.getMonth() -1);
      this.loadingTransactionRelated = true;
      this.$store
        .dispatch("ListCreditCardRefused", { 
          "Object.Customer.Identity": this.infoTransaction.Customer.Identity, 
          "CreatedDateInitial": lastMonth 
        })
        .then(response => {
          this.infoTransaction.RelatedTransactions = response.Objects;
        })
        .catch(error => this.$makeToast(undefined, "danger", "Erro ao listar as transações relacionadas", error))
        .finally(() => {
          this.loadingTransactionRelated = false;
        });
    },
    ListPaymentMethod() {
      this.$store
        .dispatch("ListPaymentMethod")
        .then(response => {
          this.paymentMethods = response;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao obter lista de tipos de pagamento", error);
        });
    },
    previousPage() {
      const qs = require("qs");
      const prev = qs.parse(this.previousPageinfo);
      const component = prev.component;
      delete prev.component;

      this.$router.push({
        name: component,
        query: {
          previous: qs.stringify(prev)
        }
      });
    },
    ComputeExpirationPix(CreatedDate, Expiration){
      const expirationDate = new Date(CreatedDate);
      expirationDate.setSeconds(expirationDate.getSeconds() + Expiration);
      return expirationDate;
    },
    OpenWriteOffBankSlip(i) {
      this.idTransaction = this.singleSales[i].IdTransaction;
      this.idMerchant = this.singleSales[i].Merchant.Id;

      this.$makeMsgBox(`Deseja cancelar este boleto?`, "Confirmar ação", this.WriteOffBankSlip);
    },
    WriteOffBankSlip() {
      this.$store
        .dispatch("SingleSaleWriteOffBankSlip", {
          idTransaction: this.idTransaction,
          idMerchant: this.idMerchant
        })
        .then(response => {
          if (response) {
            this.ListSingleSales();

            this.$makeToast(`O cancelamento do boleto foi solicitado`, "success", `Transação ${this.idTransaction}`);
          } else {
            this.$makeToast(undefined, "danger", "Erro ao solicitar baixa", error);
          }
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao solicitar baixa", error);
        });
    },
    OpenCancelCreditCard(i) {
      this.idTransaction = this.singleSales[i].IdTransaction;
      this.idMerchant = this.singleSales[i].Merchant.Id;

      this.$makeMsgBox(`Deseja estornar este pagamento?`, "Confirmar ação", this.CancelCreditCard);
    },
    CancelCreditCard() {
      this.$store
        .dispatch("SingleSaleCancelCreditCard", {
          idTransaction: this.idTransaction,
          idMerchant: this.idMerchant
        })
        .then(response => {
          if (response.isCancelled) {
            this.ListSingleSales();

            this.$makeToast(`Estorno efetuado com sucesso`, "success", `Transação ${this.idTransaction}`);
          } else {
            this.$makeToast(response.Message || "Não foi possível efetuar o estorno.", "danger", `Transação ${this.idTransaction}`);
          }
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao estornar", error);
        });
    },
    OpenCancelPix(i) {
      this.idTransaction = this.singleSales[i].IdTransaction;
      this.idMerchant = this.singleSales[i].Merchant.Id;

      if (this.singleSales[i].TransactionStatus && this.singleSales[i].TransactionStatus.Code == "19") {
        this.$makeToast("Atenção", "warning", "A devolução deste Pix já está em processamento. Aguarde a conclusão.");
        return;
      }

      this.$makeMsgBox(`Deseja estornar este pagamento?`, "Confirmar ação", this.CancelPix);
    },
    CancelPix() {
      this.$store
        .dispatch("SingleSaleCancelPix", {
          idTransaction: this.idTransaction,
          idMerchant: this.idMerchant
        })
        .then(response => {
          this.ListSingleSales();

          if (response.isCancelled) {
            this.$makeToast(`Estorno efetuado com sucesso`, "success", `Transação ${this.idTransaction}`);
          } else {
            this.$makeToast("Devolução em processamento", "info", `${response.Message}`);
          }
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao estornar", error);
        });
    },
  }
};



// WEBPACK FOOTER //
// ./src/components/pages/SingleSale/SingleSale.js